import {createReducer} from '@reduxjs/toolkit';

import {
  focusItem,
  focusItems,
  unfocusAllItems,
  unfocusItems,
} from '@src/actions/focused-item.js';
import {applyFilters} from '@src/actions/item-filters.js';
import {
  clearSearch,
  executeSearch,
  loadSearch,
  searchSingleItem,
} from '@src/actions/search';

export const initialState = [];

const focusedItems = createReducer(initialState, builder => {
  builder.addCase(focusItem, (state, {payload}) => (payload ? [payload] : []));

  builder.addCase(focusItems, (state, {payload: {items, reset}}) => {
    if (reset) {
      return items;
    }

    state.push(...items);
  });

  builder.addCase(unfocusItems, (state, {payload: {items}}) =>
    state.filter(
      focusedItem => !items.find(item => item.id === focusedItem.id),
    ),
  );

  builder.addCase(unfocusAllItems, () => initialState);
  builder.addCase(loadSearch, () => initialState);
  builder.addCase(clearSearch, () => initialState);
  builder.addCase(executeSearch, () => initialState);
  builder.addCase(searchSingleItem, () => initialState);
  builder.addCase(applyFilters, () => initialState);
});

export default focusedItems;
